module.exports = __webpack_public_path__ + "img/FONBET.8d649139.svg";